import { useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../types/common';
import { Model } from '../../types/features';
import { returnQueryConfig } from '../../utils/commonFunctions';

const useModelActions = (
  whichAction:
    | 'userModelList'
    | 'appointmentModelList'
    | 'financialModelList'
    | 'allModelList'
    | ''
) => {
  // query function to fetch user model list declared here
  const getUserModelListHandler = useQuery({
    queryKey: ['user-model-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Model>>> => {
      const response = await getPrivateAxiosInstance('user').get(
        '/users/app/models/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(
      whichAction === 'userModelList' || whichAction === 'allModelList'
    ),
  });

  // query function to fetch appointment model list declared here
  const getAppointmentModelListHandler = useQuery({
    queryKey: ['appointment-model-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Model>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/appointment/app/models/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(
      whichAction === 'appointmentModelList' || whichAction === 'allModelList'
    ),
  });

  // query function to fetch financial model list declared here
  const getFinancialModelListHandler = useQuery({
    queryKey: ['financial-model-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<Model>>> => {
      const response = await getPrivateAxiosInstance('finance').get(
        '/financial/app/models/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(
      whichAction === 'financialModelList' || whichAction === 'allModelList'
    ),
  });

  return {
    getUserModelListHandler,
    getAppointmentModelListHandler,
    getFinancialModelListHandler,
  };
};

export default useModelActions;
